import { Component, inject, input, computed, ViewEncapsulation, type InputSignal, type Signal } from '@angular/core';

import { MODAL_HEADER_CONFIG, ModalHeaderType } from '../../modal.domain';
import { IconComponent } from '../../../icon/icon.component';

@Component({
  selector: 'td-wb-modal-header',
  templateUrl: 'modal-header.component.html',
  styleUrls: ['modal-header.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [IconComponent],
  host: {
    '[class.td-wb-modal__header]': 'true',
    '[class.td-wb-modal__header--light]': 'isLight()'
  }
})
export class ModalHeaderComponent {
  private readonly defaultHeaderType: ModalHeaderType = inject(MODAL_HEADER_CONFIG, { optional: true }) ?? ModalHeaderType.DEFAULT;
  readonly iconId: InputSignal<string | undefined> = input<string>();
  readonly headerType: InputSignal<ModalHeaderType> = input<ModalHeaderType>(this.defaultHeaderType);
  readonly isLight: Signal<boolean> = computed(() => this.headerType() === ModalHeaderType.LIGHT);
}
